import cn from "classnames";
import React, { useState } from "react";
import { ProgressBar } from ".";

export default (props) => {
    return (
        <div className="card mb-3">
            <div className="card-header">
                Количество запросов в секунду: <b>{props.requestsRate.maxRequestRate}</b>
            </div>
            <div className="card-body">
                {props.requestsRate.topUsers.map((userData) => (
                    <UserRequestsRateData
                        key={userData.user}
                        {...userData}
                        overallMaxRequestsRate={props.requestsRate.maxRequestRate}
                    />
                ))}
            </div>
        </div>
    );
};

const UserRequestsRateData = (props) => {
    const [opened, setOpened] = useState(false);
    return (
        <div key={props.user} className="mb-2">
            <div className="row">
                <div className="col-sm-3 ellipsis">
                    <div
                        className={cn("d-inline-block collapse-btn", {
                            "collapse-btn--down": !opened,
                            "collapse-btn--up": opened,
                        })}
                        onClick={() => setOpened(!opened)}
                    />
                    <span title={props.user}>{props.user}</span>
                </div>
                <div className="col-sm-9 d-flex align-items-center">
                    <ProgressBar maxCount={props.overallMaxRequestsRate} count={props.maxRequestRate} />
                </div>
            </div>
            {opened && (
                <table className="table table-sm">
                    <thead>
                        <tr>
                            <td className="text-muted small">Запрос</td>
                            <td className="text-muted small">Запросов в секунду</td>
                            <td className="text-muted small">Процент от значения пользователя</td>
                            <td className="text-muted small">Процент от максимального значения</td>
                        </tr>
                    </thead>
                    <tbody>
                        {props.topRequests.map((item) => (
                            <tr key={item.path}>
                                <td>{item.path}</td>
                                <td>{item.maxRequestRate}</td>
                                <td>{Math.round((100 * item.maxRequestRate) / props.maxRequestRate)}%</td>
                                <td>{Math.round((100 * item.maxRequestRate) / props.overallMaxRequestsRate)}%</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
};
